import { render, staticRenderFns } from "./FlashNewsForm.vue?vue&type=template&id=4970c08e&"
import script from "./FlashNewsForm.vue?vue&type=script&lang=ts&"
export * from "./FlashNewsForm.vue?vue&type=script&lang=ts&"
import style0 from "./FlashNewsForm.vue?vue&type=style&index=0&id=4970c08e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports